import download from 'downloadjs';

import request from 'utils/request';

export default {
  create: async (groupId, { name }) => {
    const response = await request.post(
      `/suppliers/${groupId}/custom_tables/`,
      { name },
    );
    return response;
  },

  csvDownload: async (tableId, { type, name }) => {
    const response = await request.post(
      `/suppliers/custom_tables/csv_download/${tableId}`,
      {
        type,
      },
    );
    const blob = new Blob([response], {
      type: 'text/plain',
    });
    download(blob, `${name}-${type}.csv`);
  },

  delete: async (tableId) => {
    await request.delete(`/suppliers/custom_tables/${tableId}`);
  },

  get: async (tableId) => {
    const response = await request.get(`/suppliers/custom_tables/${tableId}`);
    return response;
  },

  list: async (groupId) => {
    const response = await request.get(`/suppliers/${groupId}/custom_tables/`);
    return response;
  },

  update: async (tableId, data) => {
    const response = await request.patch(
      `/suppliers/custom_tables/${tableId}`,
      data,
    );
    return response;
  },
};
